module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch03"
    }
  }, [_c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CHAPTER 3")])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText"
  }, [_c('span', {
    staticClass: "chapterOpenerFirstWords"
  }, [_vm._v("I"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("T MADE")]), _vm._v(" D"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("IEGO NERVOUS")])]), _vm._v(" how his mom went overboard getting their house ready for Vidas’s visit. She scrubbed the kitchen till it reeked of pine oil cleaner; ordered Eddie to gather up his scattered toys and game cartridges; arranged little clamshell soaps in the hall bathroom, warning the boys, “Don’t use these. They’re for company;” and made Diego vacuum every room.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Why do you have to make this such a big deal?” he protested.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Because he’s a guest. We need to make a good impression.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“He’s not a guest, he’s my PO!”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("His mom had always been about appearances. Never mind the truth; what mattered was how things looked. And yet, despite Diego’s gripes, it felt good to have the house so neat and tidy—the best it had looked since Mac’s death.")])]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Diego helped Eddie clean up his bedroom. Then he organized his own—plucking books off the floor, tossing clothes into the closet, and shoving junk beneath the bed. After he straightened his desk, he surveyed the room feeling proud…until he looked up at the walls. He’d forgotten about the holes.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Each of the half-dozen fist-size punctures marked an occasion when something had ticked Diego off so much that he had taken it out on the plasterboard. Once, his fist had struck a two-by-four wall stud, searing his arm with pain and spraining his wrist. That should’ve taught him his lesson, but it didn’t. The next time the rage took hold of him, he punched a new hole.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("His mom had made him cover up the punctures with posters. But he’d never dealt with the last two incidents. What would Vidas say if he saw the holes?")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Diego shifted the bikini-clad supermodel poster to cover up one puncture, but it exposed another. So then he moved his death-metal poster, but that revealed another hole. He covered that one up with a sign that he’d gotten in anger management class: "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("STOP AND THINK.")]), _vm._v(" That helped, sort of. The cracks in the plaster still showed, but hopefully not enough to notice.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("On the afternoon of Vidas’s visit, Diego arrived home to the smell of fresh-brewed coffee. His mom stood in front of her bedroom mirror, hurriedly brushing her hair and wearing a shimmery aqua-colored dress she usually put on only for special occasions like a Christmas party or Easter Sunday. Plus, she had on high heels. She "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("never")]), _vm._v(" wore high heels at home.")])]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Was she interested in Vidas? Even though she still looked pretty at thirty-four, she hadn’t dated anyone since Mac. The mere idea of her dating his PO creeped Diego out.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“You don’t need to get so dressed up,” he told her.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I want to look good,” she replied, spraying perfume onto her wrists. She rubbed them across her throat and gazed in the mirror at him. “You need to change your shirt.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Why?” He glanced down and noticed a stain from lunch. “You think he’s going to put me in jail for spilling mustard?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Hurry up!” His mom gestured impatiently as the doorbell rang. “Go change!”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“No,” Diego told her. “I’m not changing.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“You are so stubborn.” She flashed her heavily made-up eyes at him as she brushed past.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He heard the front door open, followed by his mom’s cheery voice: “"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hola")]), _vm._v(". How are you? Please come in…. Diego is changing clothes. He’ll be right out.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("She’s the one who’s stubborn,")]), _vm._v(" Diego thought, and hustled to his room. He threw his backpack onto the bed, changed into a new shirt, and checked himself in the dresser mirror, pulling the long sleeves down over his wrists. How could she harp on some miniscule mustard stain but not say anything about his cuts? Had she really not noticed them or was she just afraid to deal with them?")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("When he got to the living room, his mom was motioning Vidas to the big armchair where Mac used to sit. Upon seeing Diego’s fresh shirt, she smiled approvingly.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Hi, Diego.” Vidas extended his hand. “How are you feeling?”")])]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("The question seemed a little odd seeing as how Diego hadn’t been sick. “Um, fine,” he replied and shook hands.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Would you like some coffee?” his mom asked Vidas.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Sure, thanks.” Vidas sat down and rested a file with Diego’s name onto his lap.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("While his mom walked to the kitchen, Diego took a seat on the sofa.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“How’re your classes going?” Vidas asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Fine,” Diego said, sliding his cuffs down. “No problem.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“That’s good. What’s your favorite subject?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Biology, I guess.” As he answered, a school bus rumbled to a stop out front.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I’m home!” Eddie shouted moments later, bursting through the front door. He stopped short at the sight of Vidas. He’d obviously forgotten a visitor was coming.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Hi.” Vidas extended his hand matter-of-factly, as though he’d encountered little brothers and sisters before. “I’m Mr. Vidas.” He shook Eddie’s hand. “What’s your name?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Instead of replying, Eddie glanced at Diego uncertainly, climbing onto the sofa beside him.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Go ahead,” Diego said, nudging his brother. “Answer him.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“My name’s Eddie.” He gave Vidas a shy smile.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Their mom carried in coffee and cookies, greeting Eddie and setting the tray on the low table in front of Vidas and the boys. Eddie took a cookie but Diego resisted. His stomach was in too much of a knot.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_vm._v("“For my report,” Vidas explained while pouring cream into ")]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_vm._v("his coffee, “I’ll need to ask some questions. To start, how long have you lived in this house?”")])]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("His mom turned to Diego. “Four years?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“No, six,” he corrected. His memory was always better than hers.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Vidas clicked his pen and wrote in the file, following up with several questions about the mortgage and utilities. Then he asked, “Could you please show me around the house?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Diego’s mom led him from room to room and the boys followed behind, first through the dining room to the kitchen. Vidas glanced out the window at the backyard swing set that Mac had bought for Eddie. It barely got used anymore.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Through that door is the garage and laundry room.” Diego’s mom pointed to the door but didn’t open it. She’d avoided going into the garage since Mac’s death. Laundry had become Diego’s chore, although sometimes Eddie helped.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("They proceeded past the hall bathroom with the unused clamshell soaps to Eddie’s room, where they paused only briefly.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“And this is Diego’s room,” his mom said, picking up and quickly folding the soiled shirt he’d tossed onto the bed.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Vidas wandered slowly around the room, peering at the aquarium fish and then stopping to admire Diego’s prized Eastern Murex seashell. It was almost impossible to find one in such perfect condition, with all its spikes and wings intact.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Continuing around the room, Vidas read the titles of some books and DVDs. Then he spotted the cracks in the wall beneath the "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("STOP AND THINK")]), _vm._v(" sign.")])]), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Diego held his breath as Vidas lifted the sign and stared at the punched hole.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Did you do that?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Diego nodded, his face warming.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Stop and think,” Vidas said, tapping his head.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I know,” Diego mumbled as his mom shot him a sharp look.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Continuing over to the nightstand, Vidas picked up a framed photo of Diego with his mom and Eddie at Six Flags theme park. Diego had torn out the figure that stood beside them, leaving only a disembodied man’s arm across Diego’s shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Who was that?” Vidas asked, pointing to the space left by the ripped-out image.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Diego averted his eyes, wishing he’d stored the photo in a drawer, and waited for his mom to answer.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“That was Mac,” she said at last, her voice tinged with strain. “Diego’s stepfather, Eddie’s dad.” She gently squeezed Eddie’s shoulder. “Why don’t you go get another cookie and play in your room, so your brother and I can talk with Mr. Vidas?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Diego wished he could leave too. Their mom waited till Eddie was gone before informing Vidas in a quiet voice: “Three years ago, he committed suicide.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I didn’t realize,” Vidas said, setting the photo down. “I’m sorry.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I told Eddie it was an accident,” she explained, grabbing a tissue from the dresser to wipe her cheeks. “Shall we go sit down?”")])]), _c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("She led Vidas to the living room and Diego followed behind, feeling more and more agitated. It bothered him to hide the truth from Eddie, and it made him uneasy to see his mom upset.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Vidas once again sat in Mac’s armchair and wrote in the file. Diego’s mom dabbed at her eyes and cleared her throat, while Diego took a cookie, even though he wasn’t hungry.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He hoped Vidas would shy away from asking any more about the suicide, like most people, yet Vidas kept going.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I suspect the suicide is hard for you to talk about, but could you please tell me how it happened?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Diego kept silent, letting his mom respond. She took a breath as if to strengthen herself. “He had a gun. I didn’t like him to have it, but that’s part of who he was.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("As she spoke, Diego recalled the first time he’d seen the .45, in Mexico during a boat trip, and how the gun had seemed so terrifyingly loud, so powerful.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“He’d been in the army, in combat.” His mom pointed across the room to the bronze star framed on the wall. “He liked to go shooting at a range. It scared me to have the gun in the house with the boys, so I made him keep it locked in the garage.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In his mind, Diego pictured the metal cabinet next to the fishing tackle. The gun had felt so cold and heavy when he pulled it from the cabinet and held it in his hands.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I was at work when the police called,” his mom explained, balling up the tissue between her fingers. “They said a neighbor had heard a shot come from the garage.”")])]), _c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Diego slowly chewed his cookie, replaying his own memory of that day: how he’d come home to find the house crowded with police; his mom sobbing as she told him the news; and the sense of relief that seeped into him.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“They found Mac dead,” his mom continued. “I was in shock.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Diego had wanted to see the body, but the police said it was too ravaged. Several days later, the remains were cremated and the ashes scattered off the beach into the Gulf of Mexico. Only after that did the reality sink in: Mac was gone. Then came the guilt, like a crashing wave. Diego knew why Mac had killed himself. It was because of him. Diego had wanted Mac to die, and Mac knew it.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“How did you meet your husband?” Vidas asked, interrupting Diego’s thoughts.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“In Puerto Vallarta, where we’re from,” his mom replied. “He came for a fishing vacation and ate at the restaurant where I waitressed. He made me laugh right away. He was always a little crazy. I think that’s part of what attracted me. We fell in love very fast.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Each time she told that story, Diego wondered: Had she truly been in love with Mac? Had he really been in love with her?")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Vidas wrote something in his file and asked, “How did he and Diego get along?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Like best friends,” his mom replied. “Mac was the dad Diego never had.”")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_vm._v("Diego bit into his cookie, recalling times when Mac had ")]), _c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_vm._v("in fact seemed like the greatest dad a family could have. The fun, nice, normal-seeming Mac had brought white roses to his mom, taught Diego English, whomped up Sunday flapjacks with ice cream for everybody….")])]), _c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("But there was another side to Mac: the crazy, scary man who drank whiskey till it spilled from his glass, got into yelling fights with his mom over stupid-ass stuff, and came to Diego at night like some hurt little boy….")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Vidas glanced up from his folder at Diego. “How did that photo on your nightstand get torn?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Diego glanced at his mom, hoping she would answer again, but she gave him a cross look. “Tell him.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Um…I ripped it.” Diego’s leg began to jiggle nervously as he remembered the day after Mac’s death, when he rampaged through the house, prying picture frames open.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“He tore Mac’s face out of all our photos,” his mom elaborated. “I’m still mad about it. He destroyed them.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Diego had tossed the photo scraps into a metal kitchen bowl, doused the pile with lighter fluid, and lit a match. The smoke alarm went off with a piercing shriek, and even though he pounded the noise off, his ears rang all evening.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Vidas tapped his pen on his folder and stared at Diego. “What were you feeling?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Diego recalled years of pent-up emotion that had exploded with Mac’s suicide, and in his hand the cookie accidentally snapped into pieces.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_vm._v("“Um, sorry.” He bent down to gather the crumbs off the carpet and his mom spoke up, talking as if he wasn’t there. “I ")]), _c('a', {
    attrs: {
      "id": "page38"
    }
  }, [_vm._v("think what Mac did to him was a terrible thing.”")])]), _c('a', {
    attrs: {
      "id": "page38"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Diego sat up, alert. Vidas gave his mom a puzzled look. “You mean…?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Taking his life like that.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Vidas nodded and wrote in his folder. Then he asked, “What about Diego’s birth father? Are you in contact with him?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“No. I was only eighteen when we met. After Diego was born, he left us. I never heard from him again.” She ran her hands across her lap, smoothing her satiny dress and asked, “Are you married, Mr. Vidas?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Diego cringed. Was his mom coming onto his PO?")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Vidas leaned back in his seat as if surprised by her question. “I have a partner.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("What did that mean? That he had a girlfriend but wasn’t married? He wore what looked like a wedding band, but it was on his right hand.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Diego deposited the cookie crumbs onto the tray. For the next hour Vidas asked question after question about his health, school, behavior at home, how he got along with his brother, his mom’s two jobs and income…. Straightforward uncomplicated questions.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Anything else,” Vidas said at last, “that either of you think I should know?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I can’t think of anything,” Diego’s mom replied.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page38"
    }
  }, [_vm._v("As Vidas turned to him, a barrage of thoughts ricocheted around Diego’s brain—about cutting himself, the shark nightmares that terrified him, the unwanted flashbacks that barged into his mind—of hands, their restless fingers moving about…. ")]), _c('a', {
    attrs: {
      "id": "page39"
    }
  }, [_vm._v("But how could he mention any of that, when he hadn’t even talked about it with his mom?")])]), _c('a', {
    attrs: {
      "id": "page39"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“Nope,” he told Vidas.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“All right.” Vidas closed his folder. “I’ll get your school records. And I want to meet with you in my office.” He pulled out his planner. “Next Thursday. Four o’clock. Can you make that?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Sure.” Diego nodded anxiously. What more was Vidas going to ask? When would he finally tell him whether or not he’d have to go to jail?")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Good.” Vidas jotted the appointment onto a name card and handed it to Diego. “Be on time, okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("When they said good-bye at the front door, Vidas started to pat Diego’s shoulder, but Diego casually positioned himself out of reach. He didn’t like men to touch him—even if it was only a clap on the back or an arm across the shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("After seeing Vidas drive away, Diego retreated to his room. Sitting at his aquarium, he watched his fish dart between the tentacles of the anemone, and he thought about the visit.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Why had Vidas asked so many questions about Mac? Mac didn’t have anything to do with his court case. And why hadn’t Vidas scolded him about punching holes in the wall or tearing up the family photos? Wasn’t a PO supposed to chew him out for stuff like that? He wished Vidas would just yell at him and get it over with.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page39"
    }
  }, [_vm._v("Later that evening, when his mom called Diego to set the dinner table, an odd thing happened: Without realizing it, he started to set a place in Mac’s old spot. When he ")]), _c('a', {
    attrs: {
      "id": "page40"
    }
  }, [_vm._v("noticed what he was doing, it kind of freaked him out.")])]), _c('a', {
    attrs: {
      "id": "page40"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“What’s the matter?” his mom asked at dinner.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Nothing.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He didn’t want to think any further about Mac, and he hoped Vidas wouldn’t ask anymore.")])])]), _c('a', {
    attrs: {
      "id": "page40"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c0c649b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781416995050_ch03.vue
// module id = 87
// module chunks = 0